'use client';

import { useState, useEffect } from 'react';
import { Search01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import LiveSearchList from './LiveSearchList';
import axios from '@/lib/axios';
import { useRouter } from 'next/navigation';
import { pushToDataLayer } from '@/features/gtm/gtmUtils';
import { useAuth } from '@/features/authentication/hooks/auth';

const SearchComponent = () => {
  const { user } = useAuth();

  const router = useRouter();
  const [search, setSearch] = useState('');
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      const fetchSuggestions = async () => {
        if (search.trim().length > 1) {
          try {
            const res = await axios.get(`/api/v2/gigalogy/items/search`, {
              params: { search },
            });
            pushToDataLayer('Search', {
              search_value: search,
              member_id: user?.data?.id,
            });
            // pixelTrack('Search', {
            //   item_id: search,
            //   member_id: user?.data?.id,
            // });

            setSuggestions(res.data?.data || []);
          } catch (error) {
            console.error('Axios search error:', error);
            setSuggestions([]);
          }
        } else {
          setSuggestions([]);
        }
      };

      fetchSuggestions();
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [search]);

  const handleClearSuggestions = () => {
    setSuggestions([]);
    setSearch(''); // <-- ADD THIS LINE
  };

  const handleSearchButtonClick = (e: any) => {
    e.preventDefault();
    handleClearSuggestions();
    if (search.trim()) {
      router.push(`/shop?search=${search}`);
    }
  };

  return (
    <>
      <div className="search-module position-relative">
        <form onSubmit={handleSearchButtonClick} className="search-bar d-flex">
          <input
            type="text"
            className="search-bar__input flex-grow-1"
            placeholder="Search for product"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="search-bar__search-buttons">
            <button
              className="bg-transparent border-0 shadow-none"
              onClick={handleSearchButtonClick}
            >
              <HugeiconsIcon icon={Search01Icon} />
            </button>
            {/* todo: make it dynamic */}
            {/* <button className='bg-transparent border-0 shadow-none'>
              <HugeiconsIcon icon={CenterFocusIcon} />
            </button> */}
          </div>
        </form>

        <LiveSearchList
          suggestions={suggestions}
          clearSuggestions={handleClearSuggestions}
        />
      </div>
    </>
  );
};

export default SearchComponent;
